import React, { useEffect } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

// components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col
} from "reactstrap";

// services
import { api_GET } from "../../services/api_service.js";
import { showMessage } from "../../services/message.js";
import { getSessionCookie } from "../../services/session.js";

export default function Sidebar({routes, logo}) {  
  const session = getSessionCookie();  

  const [collapseOpen, setcollapseOpen] = React.useState(false);
  
  const toggleCollapse = () => {
    setcollapseOpen(!collapseOpen);
  };
  
  const closeCollapse = () => {
    setcollapseOpen(false);
  };

  useEffect(() => {
    createLinks();
  }, [routes]);
  
  const [routesPermission, setRoutesPermission] = React.useState([]);
  const createLinks = () => {     
    if (session.perfil == "Master")
    {
      setRoutesPermission(routes);
      return;
    }

    api_GET(`usuario/GetPermissoesAcesso/${session.usuarioId}`).then(result => {            
      if (result.status !== 200) {
        showMessage("Atenção", "Não foi possível carregar as permissões de acesso ao sistema!", 'error', null);
      }
      else{
        let _routes = [];
        routes.map(m => {
          if (result.data.filter(f => ("/" + f.permissao) == m.path || m.path == "/dashboard").length > 0)
            _routes.push(m);
        });
        
        setRoutesPermission(_routes);        
      }
    });    
  };  
  
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank"
    };
  }

    return (
      <Navbar
        className="navbar-vertical fixed-left navbar-light bg-white"
        expand="md"
        id="sidenav-main"
      >
        <Container fluid>
          {/* Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleCollapse}
          >
            <span className="navbar-toggler-icon" />
          </button>
          {/* Brand */}
          {logo ? (
            <NavbarBrand className="pt-0 pb-0 mb-0" {...navbarBrandProps}>
              <img style={{maxHeight:"5rem"}}
                alt={logo.imgAlt}
                className="navbar-brand-img"
                src={logo.imgSrc}
              />
            </NavbarBrand>
          ) : null}
          {/* Collapse */}
          <Collapse navbar className="mt-0 pt-0" isOpen={collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-md-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img alt={logo.imgAlt} src={logo.imgSrc} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="6">
                  <button
                    className="navbar-toggler"
                    type="button"
                    onClick={toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            {/* Navigation */}
            <hr className="my-0" />
            <Nav navbar>
              {routesPermission && routesPermission.filter(f => f.sidebar == true).map((prop, key) => (
                <NavItem key={key}>
                  <NavLink
                    to={prop.layout + prop.path}
                    tag={NavLinkRRD}
                    onClick={closeCollapse}
                    activeClassName="active"
                  >
                    <FontAwesomeIcon icon={prop.icon} className={"mr-2"} /> 
                    {prop.name}
                  </NavLink>
                </NavItem>
              ))}
            </Nav>
            {/* Divider */}
            <hr className="my-3" />
          </Collapse>
        </Container>
      </Navbar>
    );
  }

Sidebar.defaultProps = {
  routes: [{}]
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};
